import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Sparkles } from "lucide-react";
import { http, errMsg } from "../../lib/api";
import { Btn } from "../kit/Kit";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../ui/dialog";

const CAMPOS = [["nombre", "Razón social / nombre"], ["rfc", "RFC"], ["tipo", "Tipo (PM / PFAE)"], ["monto", "Monto (MXN)"], ["producto", "Producto"], ["plazo_meses", "Plazo (meses)"], ["tasa_anual", "Tasa anual (%)"]];
const NUM = ["monto", "plazo_meses", "tasa_anual"];

export const CrearDealDrive = ({ c }) => {
  const nav = useNavigate();
  const [est, setEst] = useState(null);
  const [p, setP] = useState(null);
  const [busy, setBusy] = useState(false);
  const abrir = (e) => { e.stopPropagation(); http.get(`/expedientes-drive/clientes/${c.id}/deal/estimar`).then((r) => setEst(r.data)).catch((x) => toast.error(errMsg(x))); };
  const leer = async () => { setBusy(true); try { const r = (await http.post(`/expedientes-drive/clientes/${c.id}/deal/proponer`, {}, { timeout: 300000 })).data; setP({ nombre: c.nombre.replace(/^Cred SFP P[MF] - \d+ - /, ""), ...Object.fromEntries(Object.entries(r.propuesta).filter(([, v]) => v != null)) }); } catch (x) { toast.error(errMsg(x)); } setBusy(false); };
  const crear = async () => {
    const body = Object.fromEntries(CAMPOS.map(([k]) => [k, NUM.includes(k) ? (p[k] === "" || p[k] == null ? null : Number(p[k])) : p[k] || null]));
    try { const r = (await http.post(`/expedientes-drive/clientes/${c.id}/deal/crear`, body)).data; toast.success("Deal creado desde Sistema"); nav(`/deals/${r.id}`); } catch (x) { toast.error(errMsg(x)); }
  };
  return (
    <>
      <Btn kind="secondary" onClick={abrir} data-testid={`expd-crear-deal-${c.id}`}><Sparkles className="h-4 w-4" />Crear deal desde Sistema</Btn>
      <Dialog open={!!est} onOpenChange={(o) => { if (!o) { setEst(null); setP(null); } }}>
        <DialogContent className="max-w-lg" data-testid="expd-deal-modal" onClick={(e) => e.stopPropagation()}>
          <DialogHeader><DialogTitle>Crear deal desde «{est?.carpeta}»</DialogTitle></DialogHeader>
          {est && !p && <div className="space-y-3 text-sm">
            <p>La IA leerá {est.a_leer.length} de {est.legibles} documento(s) legibles. Costo estimado: <b data-testid="expd-deal-costo">US${est.costo_usd_est}</b>. Nada se crea hasta que confirmes.</p>
            <ul className="list-disc pl-5 text-xs text-[#5C5850]">{est.a_leer.map((n) => <li key={n}>{n}</li>)}</ul>
            <Btn onClick={leer} disabled={busy || !est.a_leer.length} data-testid="expd-deal-leer">{busy ? "Leyendo…" : `Leer con IA (US$${est.costo_usd_est})`}</Btn></div>}
          {p && <div className="space-y-2 text-sm">
            {CAMPOS.map(([k, l]) => <label key={k} className="flex items-center justify-between gap-3"><span className="text-xs text-[#5C5850]">{l}</span>
              <input value={p[k] ?? ""} onChange={(e) => setP({ ...p, [k]: e.target.value })} className="w-60 rounded-full border border-[#E2DDD5] px-3 py-1" data-testid={`expd-deal-${k}`} /></label>)}
            {p.evidencia && <p className="text-xs text-[#8C867A]">Evidencia: {p.evidencia}</p>}
            <Btn onClick={crear} disabled={!p.nombre} data-testid="expd-deal-crear">Crear deal (etiqueta «Creado desde Sistema»)</Btn></div>}
        </DialogContent>
      </Dialog>
    </>
  );
};
